import { useContext, useEffect, useState } from "react"
import notice from "src/components/Notice"
import { StoreContext } from "src/contexts"
import CommonService from "src/services/CommonService"
import RoleService from "src/services/RoleService"
import UserService from "src/services/UserService"
import STORAGE, { getStorage, setStorage } from "../../../lib/storage"
import { useAppDispatch } from "../../../redux/hooks"
import {
  getListSystemKey,
  setListTabs,
  setUserInfo,
} from "../../../redux/slices/appGlobalSlide"
const DefaultAction = ({ children }) => {
  const isLogin = getStorage(STORAGE.TOKEN)
  const { loginStore, userStore } = useContext(StoreContext)
  const { isLoginContext, setIsLoginContext } = loginStore  
  const { user, setUser } = userStore
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)

  const getListTab = async () => {
    try {
      setLoading(true)
      const resp = await RoleService.getListTab()
      if (resp.isOk) {
        dispatch(dispatch(setListTabs(resp.Object || [])))
      }
    } catch (error) {
      console.log("Error>>DefaultAction>>getData: ", error)
      dispatch(
        setListTabs([
          {
            categoryId: 0,
            Description: "Tổng Quan",
            isVisitTab: true,
          },
        ]),
      )
    } finally {
      setLoading(false)
    }
  }
  const getSystemKey = async () => {
    try {
      setLoading(true)
      const res = await CommonService.getSystemKey("All")
      if (res.IsError) return
      dispatch(getListSystemKey(res.Object))
    } catch (error) {
      console.log("Error>>DefaultAction>>getSystemKey: ", error)
    } finally {
      setLoading(false)
    }
  }

  const updateUserInfor = async () => {
    try {
      setLoading(true)
      const resuf = await UserService.getUserByID()
      if (resuf.isOk) {
        setStorage(STORAGE.USER_INFO, resuf.Object)
        setUser(resuf.Object)
        dispatch(setUserInfo(resuf.Object))
      }
    } catch (error) {
      notice({
        msg: "Lỗi hệ thống. Vui lòng thử lại sau.",
        isSuccess: false,
      })
      console.error("DefaultAction>>updateUserInfor:", error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getSystemKey()
    setIsLoginContext(isLogin)
    if (isLogin) getListTab()
  }, [])
  useEffect(() => {
    console.log("isLoginContext", isLoginContext)

    if (isLoginContext) {
      updateUserInfor()
      setStorage(
        STORAGE.DEV_MODE,
        !!(typeof window !== "undefined" && window.env?.API_ROOT)?.IS_DEV,
      )
    }
  }, [isLoginContext])
  return <>{children}</>
}

export default DefaultAction
